'use client'
import { MatterWorkspaceModule } from '@repo/client-matter-workspaces/MatterWorkspaceModule'

const MatterWorkspace = () => {
  return <MatterWorkspaceModule />
}

export default MatterWorkspace
